import { render, staticRenderFns } from "./VisitBook.vue?vue&type=template&id=96ee3480"
import script from "./VisitBook.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitBook.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports